export enum Variant {
  LISTBOX = "LISTBOX",
  MENUBUTTON = "MENUBUTTON",
}

export enum StyleType {
  standard = "standard",
  primary = "primary",
}
